<template>
  <section class="error-page">
    <div class="content">
      <div class="error-page-block">
        <div>
          <h1 class="error-page-title">
            <span class="error-page-title__orange">
              404
            </span>
            Page Not Found</h1>
          <p class="error-page-text">Nothing could be found at this address.</p>
        </div>

        <img alt="error-page-img" src="@/assets/img/404error.png"/>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'NotFoundPage',
};
</script>
